// axios
import axios from 'axios'

// Vue Router
import router from './router'

const baseURL = "http://127.0.0.1:7002"

// import MessagePack from 'what-the-pack'
// const { encode, decode } = MessagePack.initialize(2**24);
axios.create({
  baseURL,
  timeout: 999999,
  // You can add your headers here
})
axios.interceptors.request.use(
  function(req){
    if(req.url.indexOf('delete')<0||req.url.indexOf('stop')<0||req.url.indexOf('publish')<0||req.url.indexOf('undelete')<0||req.url.indexOf('finish')<0){
      let dataJSON={};
      for(let key in req.data){
        let pro=req.data[key];
        dataJSON[key]=typeof(pro)=="string" ?pro.trim():pro;
      }
      req.data=dataJSON;
    }
    req.headers.Authorization= localStorage.getItem('Authorization');
    return req;
  },
  function (err){
    return Promise.reject(err);
  }

);

// 响应拦截器
axios.interceptors.response.use(
  function (res) {
    return res;
  }, function (err) {
    // console.log(err);
    if (err.response) {
      switch (err.response.status) {
        case 401:
          router.replace({ path: '/pages/login' });
          return Promise.reject(err.response.data.message);
        case 404:
          router.replace({ path: '/pages/error-404' });
          return Promise.reject(err.response.data.message);
          // resolve
        default:
          // console.log(err.response.status);
          router.replace({ path: '/pages/login' });
          return Promise.reject(err);
      }
    }
  })
export default axios;
